// Libraries
import {
  Pipe,
  PipeTransform
} from '@angular/core';

/**
 * `UserRolePipe` returns the role of current user.
 */
@Pipe({name: 'sheUserRole'})
export class UserRolePipe implements PipeTransform {
  /**
   * Return value OBJECT_TYPES.
   */
  transform(role: string): string {
    switch (role.toLowerCase()) {
      case 'admin':
        return 'Administrador';
      case 'supervisor':
        return 'Supervisor';
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/pipes/user-role.pipe.ts